import { Info } from "lucide-react";

const InfoTooltip = ({ text }) => (
    <div className="relative group">
      <Info className="h-4 w-4 text-gray-500 cursor-help" />
      <div className="absolute left-full top-0 ml-2 hidden group-hover:block w-64 bg-gray-800 text-white p-2 rounded-md text-sm z-[100]">
        {text}
      </div>
    </div>
  );
  
  export default InfoTooltip;